import type { Player } from '../../../types/multiplayer';

import type { PresencePayload, DatabasePlayer } from './presenceTypes';

// Map DB players to app Player objects
export function mapDbPlayersToAppPlayers(dbPlayers: DatabasePlayer[]): Player[] {
  return dbPlayers.map((player) => ({
    id: player.user_id,
    user_id: player.user_id,
    name: player.name ?? 'Player',
    avatar_url: player.avatar_url ?? '',
    is_ready: Boolean(player.is_ready),
    is_host: Boolean(player.is_host),
    status: 'online' as const,
    joined_at: player.joined_at || new Date().toISOString(),
    last_seen: new Date().toISOString(),
    score: player.score || 0,
  }));
}

// Map presence state to app Player objects (fallback)
export function mapPresenceStateToAppPlayers(state: any): any[] {
  return Object.entries(state)
    .flatMap(([key, presences]) =>
      (Array.isArray(presences) ? presences : []).map((presence: PresencePayload) => ({
        id: presence.user_id || `temp-${key}-${Math.random().toString(36).substr(2, 9)}`,
        room_id: '',
        user_id: presence.user_id,
        name: presence.name ?? '',
        nickname: presence.name ?? '',
        username: presence.name ?? '',
        score: presence.score || 0,
        avatar_url: presence.avatar_url ?? '',
        is_ready: Boolean(presence.is_ready),
        is_host: Boolean(presence.is_host),
        last_answer: undefined,
        is_correct: undefined,
        answer_time: undefined,
        created_at: presence.joined_at || new Date().toISOString(),
        isOnline: true,
        lastActive: presence.online_at || new Date().toISOString(),
        answers: [],
      }))
    )
    .filter((player, idx, self) => idx === self.findIndex(p => p.id === player.id));
}
